export default "__VITE_ASSET__b7a103de__"